import { navigate } from 'gatsby'
import React, { useContext, useState } from 'react'

import { useShoppingCart } from '../../../hooks/useShoppingCart'
import { LocaleContext } from '../../../locale/i18n'
import { Product } from '../../../logic/catalog'
import { gaEvents } from '../../../logic/ga4'
import Button, { ButtonProps } from '../../Button'

import AddedToCart from './AddedToCart'
import PricingBreakdown from './PricingBreakdown'
import ProductConfiguration from './ProductConfiguration'

interface Props {
  product: Product
}

export const AskForOfferButton = (props: ButtonProps) => {
  const { t } = useContext(LocaleContext)
  return (
    <Button
      data-gtm-id="productPageGoal"
      onClick={e => {
        e.currentTarget.blur()
        void navigate(`${location.pathname}#askForOffer`)
      }}
      {...props}
    >
      {t('productPage.productCTABanner.actionLabel')}
    </Button>
  )
}

const ProductCTABanner = ({ product }: Props) => {
  const { t } = useContext(LocaleContext)
  const [addedToCart, setAddedToCart] = useState(false)
  const { addItem } = useShoppingCart(state => ({ addItem: state.addItem }))

  if (addedToCart) {
    return (
      <AddedToCart
        hasParameters={Boolean(
          product.parameters?.length || product.tatParameter,
        )}
        onClose={() => setAddedToCart(false)}
      />
    )
  }

  if (product.webshopEnabled && product.fixedUnitPriceCents !== null) {
    return (
      <div className="rounded-lg border border-gray-200 text-sm sm:text-base">
        <ProductConfiguration
          className="flex flex-col gap-6 p-6"
          onSubmit={item => {
            setAddedToCart(true)
            addItem(item)
            gaEvents.productAddedToCart(product)
          }}
          product={product}
        />
      </div>
    )
  }

  if (
    (product.websitePricingModel === 'fixed' &&
      product.fixedUnitPriceCents === null) ||
    (product.websitePricingModel === 'estimated' &&
      product.estimatedPrice === null)
  ) {
    return <AskForOfferButton size="xl" />
  }

  return (
    <div className="rounded-lg border border-gray-300 text-sm sm:text-base">
      <div className="flex flex-col gap-6 p-6">
        <h3 className="text-center font-primary text-lg font-semibold">
          {t('productPage.productCTABanner.heading')}
        </h3>
        <PricingBreakdown product={product} />
        <AskForOfferButton size="xl" />
      </div>
    </div>
  )
}

export default ProductCTABanner
